
import {
    FETCH_LEARNING_HUB_DETAILS_REQUEST,
    FETCH_LEARNING_HUB_DETAILS_SUCCESS,
    FETCH_LEARNING_HUB_DETAILS_FAILURE,
} from '../../../Constants/actionTypes';

const initialState = {
    loading: false,
    getDetails: null,
    error: null,
};

const learningHubDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_LEARNING_HUB_DETAILS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case FETCH_LEARNING_HUB_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                getDetails: action.payload,
            };
        case FETCH_LEARNING_HUB_DETAILS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};

export default learningHubDetailsReducer;
